export default __webpack_public_path__ + "static/BannerGenericImageTextActionWithTitle-a0e19d9e227e720fb533cafa1c7cb986.jpg";